import React from "react";
import {
  OCCUPATION_LOACTION,
  NAME,
  IMG_URL,
  Company,
} from "../../../container/Constants";

const TitleName = () => {
  return (
    <div>
      <section>
        <div className="top-section">
          <div className="name-title">
            <h1 className="name">{NAME}</h1>
            <h2 className="title-location">{OCCUPATION_LOACTION}</h2>
            <h2 className="company">
              <a
                href={Company.link}
                target="_blank"
                rel="noopener noreferrer"
                className="company-link"
              >
                @{Company.name}
              </a>
            </h2>
          </div>
          <div>
            <img src={IMG_URL} alt="avater" className="avatar" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default TitleName;
